export default __webpack_public_path__ + "static/media/gallery_02.974a97d4.jpg";